import { makeStyles } from 'tss-react/mui'
import important from '../../../../utils/important'

export const useStyles = makeStyles()(() => ({
  mobileModalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  dialogBox: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 24,
    marginRight: 24,
    marginTop: 18,
  },

  entryBox: {
    justifyContent: 'space-between'
  },

  mobileEntryBox: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 0,
    paddingTop: 10,
    margin: 0
  },

  dialogPanel: {
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
  },

  progress: {
    marginTop: 30,
    width: 48,
    height: 48
  },

  entryBoxPanel: {
    marginBottom: 20,
    overflow: 'auto'
  },

  widePanel: {
    minWidth: '70%'
  },

  headerBox: {},

  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10
  },

  itemBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },

  label: {
    display: 'inline',
    fontWeight: 'bold',
    marginRight: 5
  },

  fieldIcon: {
    width: 18,
    height: 18,
    marginLeft: 4,
    marginRight: 4,
    verticalAlign: 'middle'
  },

  value: {
    display: 'inline'
  },

  yesNoRadio: {
    margin: 0,
    padding: 0,

    '& label': {
      display: 'flex',
      flexDirection: 'column-reverse',
      margin: 0,
      padding: 0,
    },
    '& .MuiFormControlLabel-asterisk': {
      display: 'none'
    },
    '& .MuiFormControlLabel-label': {
      color: '#424242',
      fontSize: 14,
      // fontFamily: 'Inter',
      fontWeight: 700,
      lineHeight: '150%',
      letterSpacing: -0.154
    },

    '& .Mui-checked svg:nth-of-type(1)': {
      color: important('#5FC2A2')
    },
    '& .Mui-checked svg:nth-of-type(2)': {
      color: important('#5FC2A2'),
      fontSize: '3.0em',
      transform: 'translateX(-12px) translateY(-12px)'
    }
  },

  bibField: {
    '& input': {
      fontSize: 30,
      color: '#00B0FF',
      padding: 4,
      textAlign: 'center',
      fontWeight: 'bold'
    },

    '& fieldset.MuiOutlinedInput-notchedOutline': {
      borderColor: important('#00B0FF'),
      borderWidth: 3,
    }
  },

  mobileBib: {
    maxWidth: 100
  },

  bibError: {
    // TODO had too add these bc ctlive-mui ChronoDialog overrides normal mui error rendering - need to fix in ctlive-mui, this works for now
    '& .MuiInputBase-root': {
      color: important('#BC3A3C')
    },
    '& fieldset.MuiOutlinedInput-notchedOutline': {
      borderColor: important('#BC3A3C')
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: important('#BC3A3C')
    }
  },

  address: {
    margin: 0
  },

  actions: {
    marginLeft: 24,
    marginRight: 24,
    marginBottom: 5
  },
  button: {
    fontWeight: 'bold'
  },
  saveButton: {
    color: '#FFFFFF'
  },
  cancelButton: {},

  bibNumber: {
    color: '#00B0FF',
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '150%',
    letterSpacing: -0.304
  },

  completedPanel: {
    '& .MuiSvgIcon-root#check-icon': {
      color: important('#5FC2A2')
    },
    '& .MuiSvgIcon-root#uncheck-icon': {
      color: important('#BC3A3C')
    },
    '& .checked-in.bib-number': {
      color: '#00B0FF'
    },
    '& .unchecked-in.bib-number': {
      color: '#BC3A3C'
    }
  },

  checkIcon: {
    width: 36,
    height: 36,
    marginTop: 9
  },

  checkedInBib: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: important('#5FC2A2'),
      borderColor: important('#5FC2A2')
    },
    '& fieldset.MuiOutlinedInput-notchedOutline': {
      borderColor: important('#5FC2A2')
    },
    '& input.Mui-disabled': {
      color: important('#FFFFFF'),
      '-webkit-text-fill-color': important('#FFFFFF'),
      backgroundColor: important('#5FC2A2')
    },
    borderColor: important('#5FC2A2')
  },

  checkedInBibLabel: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#5FC2A2',
    textTransform: 'uppercase'
  },

  uncheckin: {
    color: '#BC3A3C',
    borderColor: '#BC3A3C',
    borderWidth: 2
  }
}))
